import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

export type TokenReadyStatus = 'pending' | 'present' | 'missing';

export interface ShareState {
  tokenReadyStatus: TokenReadyStatus;
  token: string | null;
}

const initialState: ShareState = {
  tokenReadyStatus: 'pending',
  token: null,
};

const slice = createSlice({
  name: 'share',
  initialState,
  reducers: {
    setShareToken: (state, { payload }: PayloadAction<string>) => {
      state.token = payload;
      state.tokenReadyStatus = 'present';
    },
    markTokenMissing: (state) => {
      state.token = null;
      state.tokenReadyStatus = 'missing';
    },
    clearShareToken: () => initialState,
  },
});

export default slice.reducer;

export const { setShareToken, markTokenMissing, clearShareToken } = slice.actions;

export const selectViewerMode = (state: RootState) => state.share.token !== null;
export const selectTokenReadyStatus = (state: RootState) => state.share.tokenReadyStatus;
